var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['saved-card', _vm.savedCard?.walletType]},[_c('span',{staticClass:"card-number"},[_vm._v(" "+_vm._s(_vm.paymentMethodLabel)+" ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }